import styles from "./footer.module.scss";

export function Footer() {
  return (
    <div className={styles.footerWrapper}>
      <span>innoscripta SE</span>
      <span>Bahnhofstr. 17, 82327 Tutzing</span>
      <a href="https://innoscripta.com" target="_blank" rel="noopener noreferrer">
        <span>clusterix.io</span>
      </a>
    </div>
  );
}
